/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', function() {
  const cartButtons = document.querySelectorAll('button[type="submit"][name="add"], .add-to-cart');
  cartButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      setTimeout(function() {
        window.location.href = '/cart';
      }, 800); // 800 milliseconds gives the theme time to process the item add
    });
  });
});